import connect from 'components/Shared/connect';
import { Section } from 'components/Section';
import { BasePageModel } from 'models/BasePageModel';
import { NotifyLink } from 'components/Shared/NotifyLink';
import styles from './styles.scss';
import { IMenuItem } from 'models/IMenuItem';
import { hasElements, NO_ELEMENT, isLegacy } from 'utils';
import cn from 'classnames';
import { BreadCrumbs as LegacyBreadcrumbs } from '../default/breadcrumbs';
import { AppShellManifest } from 'models/AppShellManifest';

interface OwnProps {
  className?: string;
  experiment?: boolean;
}
type MergedProps = OwnProps &
  Pick<AppShellManifest, 'channel'> &
  Pick<BasePageModel, 'breadCrumbs' | 'componentName'> & {
    isContentPage: boolean;
    isProductListPage: boolean;
  };

const BreadCrumb = (props: Pick<IMenuItem, 'ticket' | 'title' | 'url'> & { position: number }) => (
  <li
    className={styles.breadCrumb}
    itemProp="itemListElement"
    itemScope
    itemType="https://schema.org/ListItem"
  >
    <span>/</span>
    <NotifyLink itemProp="item" className={styles.link} ticket={props.ticket} url={props.url}>
      <span itemProp="name">{props.title}</span>
    </NotifyLink>
    <meta itemProp="position" content={`${props.position}`} />
  </li>
);

const SHOW_ELLIPSIS_NUMBER_OF_BREADCRUMBS = 2;
const _BreadCrumbs = ({ breadCrumbs, className, channel, componentName }: MergedProps) => {
  if (isLegacy({ channel, componentName })) {
    return <LegacyBreadcrumbs />;
  }

  if (!hasElements(breadCrumbs)) {
    return NO_ELEMENT;
  }

  const showEllipsis = breadCrumbs.length > SHOW_ELLIPSIS_NUMBER_OF_BREADCRUMBS;

  return (
    <Section className={cn(styles.base, className)} contentClassName={styles.content}>
      <ol className={styles.list} itemScope itemType="https://schema.org/BreadcrumbList">
        {showEllipsis && <li className={styles.ellipsis}>...</li>}
        {breadCrumbs.map((b, i) => (
          <BreadCrumb key={b.url} position={i + 1} {...b} />
        ))}
      </ol>
    </Section>
  );
};

export const BreadCrumbs = connect<MergedProps, OwnProps>(state => ({
  breadCrumbs: state.currentPage.breadCrumbs || [],
  channel: state.appShell.channel,
  componentName: state.currentPage.componentName
}))(_BreadCrumbs);
